import { jsx as _jsx } from "react/jsx-runtime";
import { Calendar24Regular, ChevronDown24Filled, Clock24Regular, IosArrowLtr24Filled, IosArrowRtl24Regular } from '@fluentui/react-icons';
// ----------------------------------------------------------------------
const dateList = [
    'DatePicker',
    'DateTimePicker',
    'StaticDatePicker',
    'DesktopDatePicker',
    'DesktopDateTimePicker',
    //
    'MobileDatePicker',
    'MobileDateTimePicker'
];
const timeList = ['TimePicker', 'MobileTimePicker', 'StaticTimePicker', 'DesktopTimePicker'];
const switchIcon = () => _jsx(ChevronDown24Filled, {});
const leftIcon = () => _jsx(IosArrowLtr24Filled, {});
const rightIcon = () => _jsx(IosArrowRtl24Regular, {});
const calendarIcon = () => _jsx(Calendar24Regular, { color: '#919EAB' });
const clockIcon = () => _jsx(Clock24Regular, {});
const desktopTypes = dateList.reduce((result, currentValue) => {
    result[`Mui${currentValue}`] = {
        defaultProps: {
            slots: {
                openPickerIcon: calendarIcon,
                leftArrowIcon: leftIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon
            }
        }
    };
    return result;
}, {});
const timeTypes = timeList.reduce((result, currentValue) => {
    result[`Mui${currentValue}`] = {
        defaultProps: {
            slots: {
                openPickerIcon: clockIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon
            }
        }
    };
    return result;
}, {});
export function datePicker(theme) {
    return {
        MuiPickersLayout: {
            styleOverrides: {
                root: {
                // '& .MuiPickersLayout-actionBar': {
                //   [`& .${buttonClasses.root}:last-of-type`]: {
                //     // backgroundColor: theme.palette.primary.darker,
                //     color:
                //       theme.palette.mode === 'light'
                //         ? theme.palette.common.white
                //         : theme.palette.grey[800]
                //   }
                // }
                }
            }
        },
        MuiPickersArrowSwitcher: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    border: 'none',
                    '& .MuiIconButton-root:first-of-type': {
                        border: '1px solid transparent'
                    },
                    '& .MuiIconButton-root:last-of-type': {
                        border: '1px solid transparent'
                    }
                }
            }
        },
        MuiClock: {
            styleOverrides: {
                root: {
                    justifyContent: 'center',
                    marginTop: theme.spacing(6)
                }
            }
        },
        MuiDateTimePickerToolbar: {
            styleOverrides: {
                separator: {
                    lineHeight: 1.2
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    display: 'flex',
                    width: '100%',
                    '& > .MuiButton-root': {
                        flex: '1 1 0'
                    },
                    '& > .MuiButton-root:first-of-type': {
                        backgroundColor: 'transparent'
                    },
                    '& > .MuiButton-root:last-of-type': {
                        color: theme.palette.primary.contrastText
                    }
                }
            }
        },
        MuiPickersDay: {
            styleOverrides: {
            // root: {
            //   '&.Mui-selected': {
            //     backgroundColor: theme.palette.primary.main,
            //     color: theme.palette.primary.contrastText,
            //     '&:hover': {
            //       backgroundColor: theme.palette.primary.darker
            //     },
            //     '&:focus': {
            //       backgroundColor: theme.palette.primary.darker
            //     }
            //   }
            // }
            }
        },
        MuiPickersToolbarText: {
            styleOverrides: {
                root: {
                    fontFamily: 'SuisseIntl'
                }
            }
        },
        MuiPickersTabs: {
            styleOverrides: {
                root: {
                    '& .MuiTab-root.Mui-selected': {
                        color: theme.palette.common.black
                    }
                }
            }
        },
        // Date
        ...desktopTypes,
        // Time
        ...timeTypes
    };
}
